import React from "react";
import { BackButton, NextButton } from "@tripbuilder/common/custom/Buttons";

interface NavigationButtonsProps {
  currentStep: number;
  handleBack: () => void;
  handleNext: () => void;
  isLastStep: boolean;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  currentStep,
  handleBack,
  handleNext,
  isLastStep,
}) => (
  <div className="flex justify-between items-center">
    {currentStep > 0 && <BackButton onClick={handleBack} />}
    <NextButton
      onClick={handleNext}
      className={`bg-indigo-50 font-light text-xs ring-1 ring-indigo-600 hover:ring-indigo-800 py-2 rounded-full text-indigo-600 hover:bg-indigo-100 transition ease-in-out duration-500 px-3 disabled:opacity-50 disabled:cursor-not-allowed ${
        currentStep === 0 ? "ml-auto" : ""
      }`}
      isLastStep={isLastStep}
    />
  </div>
);

export default NavigationButtons;
